// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--S__gH","introduction":"hero-module--introduction--2XceY"};